import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "position-relative" }
const _hoisted_2 = { class: "text-h5 font-weight-bold mb-3" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_ScoreGrid = _resolveComponent("ScoreGrid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showLeftArrow)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 0,
          icon: "",
          class: "position-absolute z-10 elevation-2",
          style: {"left":"-56px","top":"50%","transform":"translateY(-50%)","background-color":"#262626"},
          onClick: _ctx.scrollLeft
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { color: "white" }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("mdi-chevron-left", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true),
    (_ctx.showRightArrow)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 1,
          icon: "",
          class: "position-absolute z-10 elevation-2",
          style: {"right":"-56px","top":"50%","transform":"translateY(-50%)","background-color":"#262626"},
          onClick: _ctx.scrollRight
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { color: "white" }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("mdi-chevron-right", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      ref: "scrollContainer",
      class: "overflow-x-auto snap-x snap-mandatory flex pb-4",
      onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateArrows && _ctx.updateArrows(...args)))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.panels, (panel, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "snap-center flex-shrink-0 w-full"
        }, [
          _createElementVNode("h3", _hoisted_2, [
            (panel.link)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: panel.link,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  class: "panel-title-link"
                }, _toDisplayString(panel.title), 9, _hoisted_3))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(panel.title), 1)
                ], 64))
          ]),
          _createElementVNode("p", {
            class: "text-body-2 text-grey-darken-2 mb-4",
            innerHTML: _ctx.md(panel.description)
          }, null, 8, _hoisted_4),
          _createVNode(_component_ScoreGrid, {
            "data-path": panel.dataPath,
            principles: _ctx.principles
          }, null, 8, ["data-path", "principles"])
        ]))
      }), 128))
    ], 544)
  ]))
}